import { useEffect, useState } from "react";

export function OfflineBanner() {
  const [online, setOnline] = useState(() => navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  if (online) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        background: "var(--color-warning, #ffb300)",
        color: "#000",
        padding: "var(--space-2) var(--space-3)",
        textAlign: "center",
        fontSize: 13,
      }}
    >
      You're offline. Changes will sync when you reconnect.
    </div>
  );
}
